import { useNavigate } from 'react-router-dom';

const ULTIMA_ATUALIZACAO = '21 de junho de 2026';
const EMAIL_CONTATO = 'contato@bibliotecadebolso.app';

function Secao({ titulo, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 18, fontWeight: 800, color: '#211C2B', margin: '0 0 12px', lineHeight: 1.3 }}>
        {titulo}
      </h2>
      <div style={{ fontSize: 15, color: '#4A4458', lineHeight: 1.75 }}>
        {children}
      </div>
    </section>
  );
}

function Li({ children }) {
  return (
    <li style={{ marginBottom: 6, paddingLeft: 4 }}>{children}</li>
  );
}

export default function PoliticaPrivacidade() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100dvh', background: '#FAF8F5', fontFamily: 'inherit' }}>
      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #EDE9F5', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5B3CE4', fontSize: 14, fontWeight: 700, padding: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Voltar
        </button>
        <span style={{ fontSize: 15, fontWeight: 800, color: '#211C2B' }}>Política de Privacidade</span>
      </div>

      {/* Conteúdo */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 24px 80px' }}>
        <div style={{ marginBottom: 40 }}>
          <h1 style={{ fontSize: 30, fontWeight: 800, color: '#211C2B', margin: '0 0 8px', lineHeight: 1.2 }}>
            Política de Privacidade
          </h1>
          <p style={{ fontSize: 13, color: '#9A93A4', margin: 0 }}>
            Última atualização: {ULTIMA_ATUALIZACAO}
          </p>
        </div>

        <Secao titulo="1. Quem somos">
          <p>
            O <strong>Biblioteca de Bolso</strong> é um aplicativo de compartilhamento de livros entre leitores, disponível em <strong>bibliotecadebolso.app</strong>. Somos responsáveis pelo tratamento dos seus dados pessoais conforme descrito nesta Política.
          </p>
          <p style={{ marginTop: 10 }}>
            Para dúvidas ou solicitações relacionadas à sua privacidade, entre em contato pelo e-mail: <a href={`mailto:${EMAIL_CONTATO}`} style={{ color: '#5B3CE4', fontWeight: 600 }}>{EMAIL_CONTATO}</a>
          </p>
        </Secao>

        <Secao titulo="2. Quais dados coletamos">
          <p style={{ marginBottom: 12 }}>Coletamos os seguintes dados para o funcionamento do app:</p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li><strong>Dados de cadastro:</strong> nome, endereço de e-mail e foto de perfil.</Li>
            <Li><strong>Dados do acervo:</strong> títulos, autores, avaliações e disponibilidade dos livros que você cadastra.</Li>
            <Li><strong>Histórico de empréstimos:</strong> livros emprestados e recebidos, prazos, avaliações e mensagens trocadas no fluxo de empréstimo.</Li>
            <Li><strong>Conexões sociais:</strong> perfis que você segue ou que te seguem, membros de clubes de leitura.</Li>
            <Li><strong>Dados de uso:</strong> interações com o app (clubes criados, livros explorados, notificações) para personalização da experiência.</Li>
            <Li><strong>Dados de pagamento:</strong> processados diretamente pela Stripe. Não armazenamos dados de cartão de crédito em nossos servidores.</Li>
          </ul>
        </Secao>

        <Secao titulo="3. Como usamos seus dados">
          <p style={{ marginBottom: 12 }}>Seus dados são usados exclusivamente para:</p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li>Criar e gerenciar sua conta no Biblioteca de Bolso.</Li>
            <Li>Exibir seu acervo para outros usuários que você autoriza (seguidores, membros de clube).</Li>
            <Li>Facilitar o fluxo de empréstimo de livros entre você e outros leitores.</Li>
            <Li>Enviar notificações sobre empréstimos, devoluções, clubes e conexões sociais.</Li>
            <Li>Processar pagamentos do plano Premium via Stripe.</Li>
            <Li>Melhorar o aplicativo com base em padrões de uso agregados e anônimos.</Li>
          </ul>
          <p style={{ marginTop: 12 }}>
            Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins de publicidade ou marketing.
          </p>
        </Secao>

        <Secao titulo="4. Compartilhamento de dados">
          <p style={{ marginBottom: 12 }}>Seus dados podem ser compartilhados somente com:</p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li>
              <strong>Supabase</strong> — infraestrutura de banco de dados e autenticação. Os dados são armazenados em servidores seguros com criptografia em repouso e em trânsito.
            </Li>
            <Li>
              <strong>Stripe</strong> — processamento de pagamentos. A Stripe recebe apenas as informações necessárias para completar a transação, conforme sua própria política de privacidade.
            </Li>
            <Li>
              <strong>Outros usuários do app</strong> — seu nome, foto, acervo e avaliações são visíveis para os usuários com quem você interage (seguidores, membros de clube, parceiros de empréstimo), de acordo com suas configurações de privacidade.
            </Li>
          </ul>
          <p style={{ marginTop: 12 }}>
            Podemos divulgar dados quando exigido por lei ou por ordem judicial.
          </p>
        </Secao>

        <Secao titulo="5. Seus direitos (LGPD)">
          <p style={{ marginBottom: 12 }}>
            Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você tem direito a:
          </p>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <Li><strong>Confirmação e acesso</strong> — saber quais dados temos sobre você e acessá-los.</Li>
            <Li><strong>Correção</strong> — atualizar dados incompletos, inexatos ou desatualizados diretamente no app ou por e-mail.</Li>
            <Li><strong>Exclusão</strong> — solicitar a exclusão da sua conta e de todos os seus dados. Use a opção "Excluir conta" nas configurações ou entre em contato conosco.</Li>
            <Li><strong>Portabilidade</strong> — solicitar seus dados em formato estruturado.</Li>
            <Li><strong>Revogação do consentimento</strong> — retirar seu consentimento a qualquer momento, sem prejuízo ao tratamento anterior.</Li>
            <Li><strong>Oposição</strong> — opor-se a tratamentos realizados sem seu consentimento, quando cabível.</Li>
          </ul>
          <p style={{ marginTop: 12 }}>
            Para exercer qualquer desses direitos, entre em contato pelo e-mail: <a href={`mailto:${EMAIL_CONTATO}`} style={{ color: '#5B3CE4', fontWeight: 600 }}>{EMAIL_CONTATO}</a>
          </p>
        </Secao>

        <Secao titulo="6. Retenção de dados">
          <p>
            Seus dados são mantidos enquanto sua conta estiver ativa. Ao excluir sua conta, removemos seus dados pessoais em até <strong>30 dias</strong>, exceto quando a retenção for exigida por obrigação legal (por exemplo, registros de transações financeiras exigidos pela legislação fiscal).
          </p>
        </Secao>

        <Secao titulo="7. Segurança">
          <p>
            Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda ou alteração, incluindo criptografia TLS em trânsito, autenticação segura via Supabase Auth e controle de acesso por políticas de linha (RLS).
          </p>
          <p style={{ marginTop: 10 }}>
            Em caso de incidente de segurança que afete seus dados, notificaremos você e a Autoridade Nacional de Proteção de Dados (ANPD) nos prazos previstos em lei.
          </p>
        </Secao>

        <Secao titulo="8. Cookies e armazenamento local">
          <p>
            Utilizamos armazenamento local (localStorage) apenas para preferências do app, como modo de visualização e estado de tutoriais. Não utilizamos cookies de rastreamento ou publicidade.
          </p>
        </Secao>

        <Secao titulo="9. Menores de idade">
          <p>
            O Biblioteca de Bolso não é destinado a menores de 13 anos. Não coletamos intencionalmente dados de crianças. Se você acredita que um menor forneceu dados sem consentimento, entre em contato conosco para que possamos removê-los.
          </p>
        </Secao>

        <Secao titulo="10. Alterações nesta política">
          <p>
            Podemos atualizar esta Política periodicamente. Quando houver mudanças relevantes, notificaremos você pelo app ou por e-mail. O uso continuado do app após a notificação constitui aceitação da política atualizada.
          </p>
        </Secao>

        <Secao titulo="11. Contato">
          <p>
            Para qualquer dúvida, solicitação ou reclamação sobre privacidade, entre em contato:
          </p>
          <div style={{ marginTop: 12, background: '#F0ECFE', borderRadius: 14, padding: '16px 20px' }}>
            <p style={{ margin: 0, fontWeight: 700, color: '#3F27B0' }}>Biblioteca de Bolso</p>
            <p style={{ margin: '4px 0 0', color: '#5B3CE4' }}>
              <a href={`mailto:${EMAIL_CONTATO}`} style={{ color: '#5B3CE4', fontWeight: 600 }}>{EMAIL_CONTATO}</a>
            </p>
          </div>
        </Secao>
      </div>
    </div>
  );
}
